import React, { createContext, PropsWithChildren } from 'react';

interface SubFormContextType {
  isInsideModal: boolean;
}

export const TableModalFormContext = createContext<SubFormContextType>({
  isInsideModal: false,
});

/**
 * This provider should be used if the form is rendered inside another form.
 */
const TableModalFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <TableModalFormContext.Provider
      value={{
        isInsideModal: true,
      }}
    >
      {children}
    </TableModalFormContext.Provider>
  );
};

export default TableModalFormProvider;
